import Cookies from 'js-cookie';
import { closeModal, trapFocusOnModal } from '../util/modalFocusTrap';

const hideNotices = (notices) => {
  notices.forEach((notice) => notice.classList.add('!hidden'));
};

const getCookieNoticeHtml = () => {
  const template = document.createElement('template');
  template.innerHTML = `<form class="video__notice">
        <p><b>Information pour lire la vidéo</b></p>
        <p>
          Ceci est une vidéo issue de YouTube. Etant donné que YouTube peut collecter des données personnelles, nous ne chargerons la vidéo qu'après avoir recueilli votre consentement. Plus d'informations sur leur <a href="https://www.youtube.com/t/privacy">politique de confidentialité</a>
        </p>
        <button>Autoriser le contenu de YouTube</button>
      </form>`;
  return template.content.firstChild;
};

export const handleYoutubeGDPR = () => {
  if (Cookies.get('youtube-consent') !== 'true') {
    const embeddedYoutube = document.querySelectorAll('.rll-youtube-player');
    if (embeddedYoutube) {
      embeddedYoutube.forEach((youtubeIframe) => {
        const notice = getCookieNoticeHtml();
        youtubeIframe.appendChild(notice);
      });
      const notices = document.querySelectorAll('.video__notice');
      notices.forEach((notice) => {
        notice.addEventListener('submit', (event) => {
          hideNotices(notices);
          Cookies.set('youtube-consent', 'true', { expires: 365 });
          event.preventDefault();
        });
      });
    }
  }
};

export const handleCookiesSettingsUpdate = () => {
  const gdprModal = document.querySelector('#gdpr-modal');
  const cookiesForm = document.querySelector('#gdpr-modal form');
  cookiesForm.addEventListener('submit', (event) => {
    const formData = new FormData(cookiesForm);
    const youtubeConsent = formData.get('youtube') === 'on';
    if (youtubeConsent) {
      Cookies.set('youtube-consent', 'true', { expires: 365 });
    } else {
      Cookies.set('youtube-consent', 'false');
    }
    closeModal(gdprModal);
    event.preventDefault();
  });
};

export const handleGDPRModal = () => {
  const trigger = document.getElementById('gdpr-button');
  const modal = document.getElementById('gdpr-modal');
  if (trigger && modal) {
    trapFocusOnModal({ modal, trigger });
  }
};
